import { Footer } from "../components/Footer"
import { PayoutACHMethods } from "../components/payout/PayoutACHMethods"


export const PayoutACHPage = () => {
    return (
        <div className="container">
            <PayoutACHMethods />
            <Footer />
        </div>
    );
}